import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/loginSignup.css";

const LoginSignup = () => {
    const [state, setState] = useState("Login");
    const [formData, setFormData] = useState({ name: "", email: "", password: "" });
    const [token, setToken] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const navigate = useNavigate();

    const changeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleAuth = async (url) => {
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (data.token) {
                localStorage.setItem("Bearer", data.token);
                setToken(data.token);
            } else {
                alert(data.error || "Authentication failed");
            }
        } catch (error) {
            console.error("Auth error:", error);
        }
    };

    const login = () => handleAuth(`${process.env.REACT_APP_URL}/api/user/login`);

    const register = () => {
        if (!isChecked) return; 
        handleAuth(`${process.env.REACT_APP_URL}/api/user/register`);
    };

    useEffect(() => {
        if (token) {
            const mergeCart = async () => {
                const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];

                if (guestCart.length > 0) {
                    try {
                        const response = await fetch(`${process.env.REACT_APP_URL}/api/cart/mergecart`, {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ guestCart }),
                        });

                        if (response.ok) {
                            window.location.reload();
                        } else {
                            console.error("Failed to merge cart");
                        }
                    } catch (error) {
                        console.error("Error merging cart:", error);
                    }
                }
            };

            mergeCart();
            navigate("/");
        }
    }, [token, navigate]);

    return (
        <div className="loginsignup">
            <div className="loginsignup-container">
                <h1>{state}</h1>
                <div className="loginsignup-fields">
                    {state === "Register" && <input name="name" value={formData.name} onChange={changeHandler} type="text" placeholder="Your Name" />}
                    <input name="email" value={formData.email} onChange={changeHandler} type="email" placeholder="Your Email" />
                    <input name="password" value={formData.password} onChange={changeHandler} type="password" placeholder="Password" />
                </div>
                

                <div className="tooltip-wrapper" onMouseEnter={() => setShowTooltip(!isChecked)} onMouseLeave={() => setShowTooltip(false)}>
                    <button 
                        onClick={state === "Login" ? login : register} 
                        className={state === "Register" && !isChecked ? "disabled-button" : ""}
                    >
                        Continue
                    </button>
                    {showTooltip && state === "Register" && !isChecked && (
                        <span className="tooltip">⚠️ You must agree to the terms before continuing.</span>
                    )}
                </div>

                {state === "Register" ? (
                    <p className="loginsignup-login">
                        Already have an account? <span onClick={() => setState("Login")}>Login here</span>
                    </p>
                ) : (
                    <p className="loginsignup-login">
                        Don't have an account? <span onClick={() => setState("Register")}>Register here</span>
                    </p>
                )}

                {state === "Register" && (
                    <div className="loginsignup-agree">
                        <input 
                            type="checkbox" 
                            checked={isChecked} 
                            onChange={() => setIsChecked(!isChecked)} 
                        />
                        <p>By continuing, I agree to the terms of use & privacy policy.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginSignup;

